import { render, staticRenderFns } from "./SavedListContainer.vue?vue&type=template&id=64b28a56&"
import script from "./SavedListContainer.vue?vue&type=script&lang=js&"
export * from "./SavedListContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports